import posthog from 'posthog-js';

export function trackAssessmentStarted(data) {
    posthog.capture('started', {
        ...data
    });
}

export function trackAssessmentEnded(data) {
    posthog.capture('completed', {
        ...data
    });
}

export function trackLoggenIn(email) {
    posthog.identify(
        email,  // Replace 'distinct_id' with your user's unique identifier
    );
}